// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MaterialFlow from '../MaterialFlow/MaterialFlow';

export default function MaterialFlowModal({ isOpen, onClose, timestamp, deviceId = null }) {
  if (!isOpen) {
    return null; // Don't render anything if modal is not open
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="material-flow-modal-title"
      aria-describedby="material-flow-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '85vw',
        height: '85vh',
        bgcolor: '#333', 
        boxShadow: 24,
        p: 0, 
        overflow: 'hidden',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        outline: 'none',
      }}>
        {/* Header Bar */}
        <Box sx={{
          height: '30px',
          bgcolor: '#000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: 1
        }}>
          <IconButton 
            aria-label="close"
            onClick={onClose}
            sx={{
              color: '#fff',
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        
        {/* Content Area */}
        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
          {/* Conditionally render MaterialFlow based on timestamp */}
          {timestamp ? (
            <MaterialFlow timestamp={timestamp} deviceId={deviceId} style={{ height: '100%', width: '100%' }} />
          ) : (
            // Optional: Add a loading indicator or placeholder if timestamp is initially null
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#fff' }}>
              Loading Material Flow...
            </Box>
          )}
        </Box>
        
      </Box>
    </Modal>
  );
} 